import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";

export const findDynamic = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/dynamic_form?` + params,
    method: "GET",
  });
};
//添加动态表单
export const addDynamic = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/dynamic_form`,
    method: "POST",
    data: params,
  });
};
export const getDynamicForm = (id) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/dynamic_form/${id}`,
    method: "GET",
  });
};
export const updateDynamic = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/dynamic_form`,
    method: "PUT",
    data: params,
  });
};
export const findProject = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-work/v2/project/select?` + params,
    method: "GET",
  });
};
export const findAllSuperiorDepartment = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
    method: "GET",
  });
};
export const findProvince = () => {
  return request({
    url: `${baseUrl}/joins-basic/v1/province`,
    method: "GET",
  });
};
export const findCitys = (id) => {
  return request({
    url: `${baseUrl}/joins-basic/v1/province/citys/${id}`,
    method: "GET",
  });
};
export const findAreas = (id) => {
  return request({
    url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
    method: "GET",
  });
};
/**
 * 控件类型列表
 */
export const findDataSourceFields = () => {
  return request({
    url: `${baseUrl}/joins-work/v1/dataSource/fields`,
    method: "GET",
  });
};
/**
 * 数据源
 */
export const findDataSourceAll = () => {
  return request({
    url: `${baseUrl}/joins-work/v1/dataSource`,
    method: "GET",
  });
};
/**
 * 
 * @description 获取计费规则列表
 * @returns 
 */
export const findBillingRule = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/price_config`,
    method: "GET",
  });
};
export const delDynamic = (deleteOption, ids) => {
  let temp = ids.join(",");
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/dynamic_form/${temp}?option=${deleteOption}`,
    method: "DELETE",
  });
};
export const stockRemovalReturn = (data) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/app_engineering_order/update`,
    method: "PUT",
    data: data,
  });
};
